<template>
  <div class="JOB-ITEM">
    <div class="d-flex p-1 p-2:t">
      <div class="d-flex fd-column jc-between flex-1-1 m-x-1 m-x-2:t">
        <div class="GHOST-BOX x-pulse m-b-1"/>
        <div class="GHOST-BOX SMALL x-pulse"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'job-item-ghost',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .JOB-ITEM {
    & + &,
    &:first-of-type {
      border-top: 1px solid $color-gray40;
    }

    &:last-of-type {
      border-bottom: 1px solid $color-gray40;
    }

    @include tablet() {
      border-left: 1px solid $color-gray40;
      border-right: 1px solid $color-gray40;
    }
  }

  .GHOST-CIRCLE {
    @include square(50px);
    border-radius: 50%;
  }

  .GHOST-BOX {
    height: 20px;
    @include responsive(width, 250px, 400px);

    &.SMALL {
      @include responsive(width, 100px, 300px);
    }
  }
</style>
